import { Component, OnInit } from '@angular/core';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
    selector: 'app-revent-activity-list',
    templateUrl: './revent-activity-list.component.html',
    styleUrls: ['./revent-activity-list.component.scss'],
    standalone: false
})
export class ReventActivityListComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 'customerId', header: 'Customer ID', width: '15%' },
    { field: 'typeOfOrder', header: 'Type of Order', width: '20%' },
    { field: 'date', header: 'Date', width: '15%' },
    { field: 'time', header: 'Time', width: '15%' },
    { field: 'quantity', header: 'Quantity', width: '15%' },
    { field: 'location', header: 'Location', width: '20%' },
    { field: 'status', header: 'Status', width: '25%' },
    { field: 'action', header: 'Edit', width: '80%', toggleable: false },
  ];

  recentActivities: any = [];
  pageNo: number = 1;
  totalRecords:number = 10;
  constructor() { }

  ngOnInit(): void {
    this.recentActivities = [
      { customerId: 28463767, typeOfOrder: 'Logo Document_1', date: '08/06/23', time: '09:00 AM', quantity: 23, location: 'Coimbatore',status: 'Pending', action: '' },
      { customerId: 28463767, typeOfOrder: 'Logo Document_2', date: '08/06/23', time: '09:00 AM', quantity: 23, location: 'Coimbatore',status: 'Cancelled', action: '' },
      { customerId: 28463767, typeOfOrder: 'Logo Document_3', date: '08/06/23', time: '09:00 AM', quantity: 23, location: 'Coimbatore',status: 'Cancelled', action: '' },
      { customerId: 28463767, typeOfOrder: 'Logo Document_4', date: '08/06/23', time: '09:00 AM', quantity: 23, location: 'Coimbatore',status: 'Pending', action: '' },
      { customerId: 28463767, typeOfOrder: 'Logo Document_5', date: '08/06/23', time: '09:00 AM', quantity: 23, location: 'Coimbatore',status: 'Pending', action: '' },
  ]
  }

  onPageChange(event:any){
     }
}
